import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

interface ProviderOrFacilityProps {
  value: string;

  setValue(x: string): void;
}

const ProviderOrFacilityRadioButtons = ({ value, setValue }: ProviderOrFacilityProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  return (
    <FormControl sx={{ margin: '0 5px' }}>
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel value="practitioner" control={<Radio size="small" />} label="Search provider" />
        <FormControlLabel value="organization" control={<Radio size="small" />} label="Search facility" />
      </RadioGroup>
    </FormControl>
  );
};

export default ProviderOrFacilityRadioButtons;
